<template>
  <span v-if="labelMode">
    {{ labelValue }}
    <span class="mr-1 ml-1" v-html="label"></span>
  </span>
  <div
  v-else
  class="crx-input mod-parent">

      <input
      v-model="localQuantity"
      @focus="onFocus"
      @blur="localFocussed = false"
      spellcheck="false"
      />

      <span class="mr-1 ml-1" v-html="label"></span>

      <v-btn
      v-if="!fixed"
      icon
      small
      key="key4"
      @click="showMenu = !showMenu">
        <v-icon small>
        {{ showMenu ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
        </v-icon>
      </v-btn>


    <div
    v-show="showMenu"
    tabindex="1"
    class="my-dropdown">

      <v-layout class="ma-1">
        <v-icon>search</v-icon>

        <input
        placeholder="Search"
        v-model="search"
        class="crx-input-no-border"
        @click="showMenu = true"
        spellcheck="false"
        />
      </v-layout>

      <v-list v-if="filteredList.length > 0">

        <v-list-item 
        v-for="(item) in filteredList"
        :key="item.id"
        @click.prevent="selectItem(item)">

          <v-chip outlined color="blue">
            {{ item.symbol }}
          </v-chip>

          <v-list-item-title> {{ item.name }} </v-list-item-title>
        
        </v-list-item>

      </v-list>
      <v-list-item v-else>
        No matches
      </v-list-item>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    currency: {
      default: null
    },
    fixed: {
      default: true
    },
    quantity: {
      default: 0
    },
    focussed: {
      default: false
    },
    labelMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localQuantity: this.quantity,
      search: '',
      showMenu: false,
      localCurrency: this.currency, // null or an object
      localFocussed: this.focussed
    }
  },
  methods: {
    onFocus (event) {
      event.target.select()
      this.localFocussed = true
    },
    selectItem (item) {
      this.$emit('on-item-selected', item)
      this.localCurrency = item
      this.hideMenu() // catches no hide event when reselecting the item already selected and therefore not triggering a watch search() update
    },
    hideMenu () {
      this.showMenu = false
    }
  },
  computed: {
    ...mapGetters({
      defaultCurrency: 'db/currencies/getDefaultCurrency'
    }),
    labelValue () {
      var value = Number(this.quantity).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
      if (value === '-0.00') {
        return '0.00'
      }
      return value
    },
    currencyObject () {
      return this.$store.state.db.currencies.items[this.currency]
    },
    filteredList () {
      return Object.values(this.$store.state.db.currencies.items).filter(item => {
        return (item.symbol + item.name).toLowerCase().indexOf(this.search.toLowerCase()) > -1
      }).slice(0, 10)
    },
    label () {
      var symbol = this.currencyObject ? this.currencyObject.symbol : '?'
      if (symbol === 'EUR') {
        return '&euro;'
      }
      return symbol
    }
  },
  watch: {
    // props
    currency (nv) {
      this.localCurrency = nv
    },
    quantity (nv) {
      this.localQuantity = nv
    },
    // local
    localCurrency: function (nv) {
      this.$emit('update:currency', nv)
    },
    localQuantity (nv) {
      this.$emit('update:quantity', nv)
    },
    localFocussed (nv) {
      this.$emit('update:focussed', nv)
    }
  }
}
</script>

<style scoped>
.mod-parent {
  flex-direction: row;
  align-items: baseline;
}
.crx-input input {
  text-align: left;
}
.crx-input:focus-within input {
  text-align: left;
}
</style>
